import { FC } from 'react';
import { Nullable } from 'primereact/ts-helpers';
import { useTranslation } from 'react-i18next';
import InputTextField from '../../InputTextField/InputTextField';
import InputDateField from '../../InputDateField/InputDateField';
import styles from './ScheduleTableFilters.module.scss';
import { TableFilters } from '../types';

type ScheduleTableFiltersProps = {
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
  clearFilters: () => void;
};

const ScheduleTableFilters: FC<ScheduleTableFiltersProps> = ({
  filters,
  setFilters,
  clearFilters,
}) => {
  const { t } = useTranslation('schedule');

  const handleFilterChange = (
    value: string | Nullable<Date>,
    field: keyof TableFilters
  ) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };

    setFilters(newFilters);
  };

  return (
    <div className={styles.scheduleTableFilters}>
      <InputTextField
        id="shipName"
        name="shipName"
        value={filters.shipName}
        onChange={(e) => handleFilterChange(e.target.value, 'shipName')}
        label={t('tableFilters.shipName')}
        placeholder={t('tableFilters.shipNamePlaceholder')}
      />
      <InputTextField
        id="service"
        name="service"
        value={filters.service}
        onChange={(e) => handleFilterChange(e.target.value, 'service')}
        label={t('tableFilters.service')}
        placeholder={t('tableFilters.servicePlaceholder')}
      />
      <InputDateField
        id="startOperations"
        name="startOperations"
        value={filters.startOperations}
        onChange={(e) => handleFilterChange(e, 'startOperations')}
        label={t('tableFilters.startOperations')}
        className={styles.dateField}
        readOnlyInput
      />
      <InputDateField
        id="endOperations"
        name="endOperations"
        value={filters.endOperations}
        onChange={(e) => handleFilterChange(e, 'endOperations')}
        label={t('tableFilters.endOperations')}
        className={styles.dateField}
        readOnlyInput
      />
      <InputDateField
        id="openingStacking"
        name="openingStacking"
        value={filters.openingStacking}
        onChange={(e) => handleFilterChange(e, 'openingStacking')}
        label={t('tableFilters.openingStacking')}
        className={styles.dateField}
        readOnlyInput
      />
      <InputDateField
        id="closingStacking"
        name="closingStacking"
        value={filters.closingStacking}
        onChange={(e) => handleFilterChange(e, 'closingStacking')}
        label={t('tableFilters.closingStacking')}
        className={styles.dateField}
        readOnlyInput
      />
      <button onClick={clearFilters} type="button">
        {t('tableFilters.clearFilters')}
      </button>
    </div>
  );
};

export default ScheduleTableFilters;
